import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { historyShape } from 'constants/propTypes';
import Toast from 'components/ui/Toast';
import ProtectedRoute from 'components/ui/ProtectedRoute';
import WarningMessage from 'components/ui/WarningMessage';
import ErrorBoundary from 'components/errors/ErrorBoundary';
import Header from 'components/shared/Header';
import ResetPassword from 'pages/ResetPassword';

import { GlobalStyle, Main } from './App.styles';
import { protectedRoutes } from './routes';

// Workaround for https://github.com/styled-components/styled-components/issues/2227
import { fonts } from 'themes/default';
import LoginComponent from 'pages/Login/Login';

const App = ({ history }) => {
  history.listen(() => {
    window.scrollTo(0, 0);
  });

  return (
    <>
      <style>{fonts.imports}</style>
      <GlobalStyle />
      <Header />
      <Main>
        <ErrorBoundary>
          <Switch>
            {protectedRoutes.map(({ path, exact, component }) => (
              <ProtectedRoute key={path} component={component} exact={exact} path={path} />
            ))}
            <Route path="/resetPassword" component={ResetPassword} />
            <Route path="/login" component={LoginComponent} />
          </Switch>
        </ErrorBoundary>
      </Main>
      <Toast>{({ toast }) => toast && <WarningMessage>{toast}</WarningMessage>}</Toast>
    </>
  );
};

App.propTypes = {
  history: historyShape
};

export default App;
